export default __webpack_public_path__ + "static/media/profile-active.fba5b84f.svg";